import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Modal } from 'semantic-ui-react';

import ConsoleErrorMessage from '../utils/console-error-message';

import { errorType } from '../types';

import { clearError, sendResetPasswordRequest } from '../../modules/account';

class ResetPassword extends Component {
  state = {
    error: false,
    submitted: false,
  }

  componentDidMount() {
    const { connectedClearError } = this.props;
    connectedClearError();
  }

  componentDidUpdate(prevProps) {
    const { error, requestOut } = this.props;
    if (prevProps.requestOut === true && requestOut === false) {
      if (error) {
        this.setState({ error: true }); // eslint-disable-line react/no-did-update-set-state
      }
    }
  }

  handleClick = (event) => {
    const { connectedSendResetPasswordRequest } = this.props;
    event.preventDefault();
    connectedSendResetPasswordRequest();
    this.setState({
      submitted: true,
    });
  }

  handleModalClose = () => {
    const { connectedClearError } = this.props;
    connectedClearError();
    this.setState({
      error: false,
      submitted: false,
    });
  }

  renderSuccessModal = () => (
    <Modal open onClose={this.handleModalClose}>
      <Modal.Header content="Email Sent" />
      <Modal.Content>
          Successfully sent password reset email. Check your email for the next steps.
          If you ignore this email, your password will not be reset.
      </Modal.Content>
    </Modal>
  )

  renderErrorModal = () => {
    const { error } = this.props;
    return (
      <Modal header="Error" open onClose={this.handleModalClose}>
        <Modal.Header content="Error" />
        <Modal.Content>
          <ConsoleErrorMessage error={error} showSignIn={false} />
        </Modal.Content>
      </Modal>
    );
  }

  render() {
    const { requestOut } = this.props;
    const { error, submitted } = this.state;
    const success = !error && !requestOut && submitted;
    return (
      <div>
        <Button
          content="Reset Password"
          loading={requestOut}
          onClick={this.handleClick}
          primary
          size="small"
        />
        { success && this.renderSuccessModal() }
        { error && this.renderErrorModal() }
      </div>
    );
  }
}

ResetPassword.propTypes = {
  connectedClearError: PropTypes.func.isRequired,
  error: errorType,
  requestOut: PropTypes.bool.isRequired,
  connectedSendResetPasswordRequest: PropTypes.func.isRequired,
};

ResetPassword.defaultProps = {
  error: undefined,
};

const mapStateToProps = state => ({
  error: state.account.error,
  requestOut: state.account.resetPasswordRequestOut,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  connectedClearError: clearError,
  connectedSendResetPasswordRequest: sendResetPasswordRequest,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ResetPassword);
